module.exports = __webpack_public_path__ + "static/media/49_tn.1d3a66d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/49_tn.jpg
// module id = 685
// module chunks = 0